import { Card } from '../types';

export const mockCards: Card[] = [
  {
    id: '1',
    title: 'LeBron James 2003 Topps Chrome Rookie Card',
    player: 'LeBron James',
    team: 'Cleveland Cavaliers',
    year: 2003,
    brand: 'Topps Chrome',
    condition: 'Near Mint',
    grade: 'PSA 10',
    price: 25000,
    priceChange: 8.5,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=LeBron+2003+PSA+10',
    description: 'LeBron James 2003 Topps Chrome Rookie Card in PSA 10 condition. One of the most iconic rookie cards in basketball history.',
    ebayUrl: 'https://www.ebay.com/itm/example1',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '2',
    title: 'Michael Jordan 1986 Fleer Rookie Card',
    player: 'Michael Jordan',
    team: 'Chicago Bulls',
    year: 1986,
    brand: 'Fleer',
    condition: 'Mint',
    grade: 'PSA 9',
    price: 15000,
    priceChange: 12.7,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Jordan+1986+PSA+9',
    description: 'Michael Jordan 1986 Fleer Rookie Card in PSA 9 condition. The holy grail of basketball cards.',
    ebayUrl: 'https://www.ebay.com/itm/example2',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '3',
    title: 'Tom Brady 2000 Playoff Contenders Rookie Card',
    player: 'Tom Brady',
    team: 'New England Patriots',
    year: 2000,
    brand: 'Playoff Contenders',
    condition: 'Near Mint',
    grade: 'PSA 10',
    price: 18000,
    priceChange: 5.3,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Brady+2000+PSA+10',
    description: 'Tom Brady 2000 Playoff Contenders Rookie Card in PSA 10 condition. The GOAT of football cards.',
    ebayUrl: 'https://www.ebay.com/itm/example3',
    sport: 'football',
    isGraded: true,
  },
  {
    id: '4',
    title: 'Mike Trout 2011 Topps Update Rookie Card',
    player: 'Mike Trout',
    team: 'Los Angeles Angels',
    year: 2011,
    brand: 'Topps Update',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 12000,
    priceChange: -2.8,
    isHot: false,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Trout+2011+PSA+10',
    description: 'Mike Trout 2011 Topps Update Rookie Card in PSA 10 condition. The modern baseball GOAT.',
    ebayUrl: 'https://www.ebay.com/itm/example4',
    sport: 'baseball',
    isGraded: true,
  },
  {
    id: '5',
    title: 'Kobe Bryant 1996 Topps Chrome Rookie Card',
    player: 'Kobe Bryant',
    team: 'Los Angeles Lakers',
    year: 1996,
    brand: 'Topps Chrome',
    condition: 'Near Mint',
    price: 8000,
    priceChange: 15.2,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Kobe+1996+Raw',
    description: 'Kobe Bryant 1996 Topps Chrome Rookie Card in Near Mint condition. Raw card with excellent centering.',
    ebayUrl: 'https://www.ebay.com/itm/example5',
    sport: 'basketball',
    isGraded: false,
  },
  {
    id: '6',
    title: 'Patrick Mahomes 2017 Panini Prizm Rookie Card',
    player: 'Patrick Mahomes',
    team: 'Kansas City Chiefs',
    year: 2017,
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 9500,
    priceChange: 10.8,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Mahomes+2017+PSA+10',
    description: 'Patrick Mahomes 2017 Panini Prizm Rookie Card in PSA 10 condition. Future Hall of Famer.',
    ebayUrl: 'https://www.ebay.com/itm/example6',
    sport: 'football',
    isGraded: true,
  },
  {
    id: '7',
    title: 'Shohei Ohtani 2018 Topps Chrome Rookie Card',
    player: 'Shohei Ohtani',
    team: 'Los Angeles Angels',
    year: 2018,
    brand: 'Topps Chrome',
    condition: 'Near Mint',
    price: 3500,
    priceChange: -5.4,
    isHot: false,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Ohtani+2018+Raw',
    description: 'Shohei Ohtani 2018 Topps Chrome Rookie Card in Near Mint condition. Two-way superstar.',
    ebayUrl: 'https://www.ebay.com/itm/example7',
    sport: 'baseball',
    isGraded: false,
  },
  {
    id: '8',
    title: 'Stephen Curry 2009 Topps Chrome Rookie Card',
    player: 'Stephen Curry',
    team: 'Golden State Warriors',
    year: 2009,
    brand: 'Topps Chrome',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 7500,
    priceChange: 3.2,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Curry+2009+PSA+10',
    description: 'Stephen Curry 2009 Topps Chrome Rookie Card in PSA 10 condition. Three-point revolution.',
    ebayUrl: 'https://www.ebay.com/itm/example8',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '9',
    title: 'Aaron Rodgers 2005 Topps Chrome Rookie Card',
    player: 'Aaron Rodgers',
    team: 'Green Bay Packers',
    year: 2005,
    brand: 'Topps Chrome',
    condition: 'Near Mint',
    price: 2800,
    priceChange: -8.1,
    isHot: false,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Rodgers+2005+Raw',
    description: 'Aaron Rodgers 2005 Topps Chrome Rookie Card in Near Mint condition. Future Hall of Famer.',
    ebayUrl: 'https://www.ebay.com/itm/example9',
    sport: 'football',
    isGraded: false,
  },
  {
    id: '10',
    title: 'Ronald Acuña Jr. 2018 Topps Chrome Rookie Card',
    player: 'Ronald Acuña Jr.',
    team: 'Atlanta Braves',
    year: 2018,
    brand: 'Topps Chrome',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 4200,
    priceChange: 18.9,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Acuna+2018+PSA+10',
    description: 'Ronald Acuña Jr. 2018 Topps Chrome Rookie Card in PSA 10 condition. Dynamic outfielder.',
    ebayUrl: 'https://www.ebay.com/itm/example10',
    sport: 'baseball',
    isGraded: true,
  },
  {
    id: '11',
    title: 'Kevin Durant 2007 Topps Chrome Rookie Card',
    player: 'Kevin Durant',
    team: 'Seattle SuperSonics',
    year: 2007,
    brand: 'Topps Chrome',
    condition: 'Near Mint',
    price: 3200,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Durant+2007+Raw',
    description: 'Kevin Durant 2007 Topps Chrome Rookie Card in Near Mint condition. Scoring machine.',
    ebayUrl: 'https://www.ebay.com/itm/example11',
    sport: 'basketball',
    isGraded: false,
  },
  {
    id: '12',
    title: 'Josh Allen 2018 Panini Prizm Rookie Card',
    player: 'Josh Allen',
    team: 'Buffalo Bills',
    year: 2018,
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 3800,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Allen+2018+PSA+10',
    description: 'Josh Allen 2018 Panini Prizm Rookie Card in PSA 10 condition. Dual-threat quarterback.',
    ebayUrl: 'https://www.ebay.com/itm/example12',
    sport: 'football',
    isGraded: true,
  },
  {
    id: '13',
    title: 'Juan Soto 2018 Topps Chrome Rookie Card',
    player: 'Juan Soto',
    team: 'Washington Nationals',
    year: 2018,
    brand: 'Topps Chrome',
    condition: 'Near Mint',
    price: 2100,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Soto+2018+Raw',
    description: 'Juan Soto 2018 Topps Chrome Rookie Card in Near Mint condition. Young hitting phenom.',
    ebayUrl: 'https://www.ebay.com/itm/example13',
    sport: 'baseball',
    isGraded: false,
  },
  {
    id: '14',
    title: 'Giannis Antetokounmpo 2013 Panini Prizm Rookie Card',
    player: 'Giannis Antetokounmpo',
    team: 'Milwaukee Bucks',
    year: 2013,
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 6800,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Giannis+2013+PSA+10',
    description: 'Giannis Antetokounmpo 2013 Panini Prizm Rookie Card in PSA 10 condition. The Greek Freak.',
    ebayUrl: 'https://www.ebay.com/itm/example14',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '15',
    title: 'Joe Burrow 2020 Panini Prizm Rookie Card',
    player: 'Joe Burrow',
    team: 'Cincinnati Bengals',
    year: 2020,
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 1800,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Burrow+2020+Raw',
    description: 'Joe Burrow 2020 Panini Prizm Rookie Card in Near Mint condition. Heisman winner.',
    ebayUrl: 'https://www.ebay.com/itm/example15',
    sport: 'football',
    isGraded: false,
  },
  {
    id: '16',
    title: 'Fernando Tatis Jr. 2019 Topps Chrome Rookie Card',
    player: 'Fernando Tatis Jr.',
    team: 'San Diego Padres',
    year: 2019,
    brand: 'Topps Chrome',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 2900,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Tatis+2019+PSA+10',
    description: 'Fernando Tatis Jr. 2019 Topps Chrome Rookie Card in PSA 10 condition. Electric shortstop.',
    ebayUrl: 'https://www.ebay.com/itm/example16',
    sport: 'baseball',
    isGraded: true,
  },
  {
    id: '17',
    title: 'Luka Dončić 2018 Panini Prizm Rookie Card',
    player: 'Luka Dončić',
    team: 'Dallas Mavericks',
    year: 2018,
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 4200,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Luka+2018+Raw',
    description: 'Luka Dončić 2018 Panini Prizm Rookie Card in Near Mint condition. Slovenian sensation.',
    ebayUrl: 'https://www.ebay.com/itm/example17',
    sport: 'basketball',
    isGraded: false,
  },
  {
    id: '18',
    title: 'Justin Herbert 2020 Panini Prizm Rookie Card',
    player: 'Justin Herbert',
    team: 'Los Angeles Chargers',
    year: 2020,
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 3200,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Herbert+2020+PSA+10',
    description: 'Justin Herbert 2020 Panini Prizm Rookie Card in PSA 10 condition. Rookie of the Year.',
    ebayUrl: 'https://www.ebay.com/itm/example18',
    sport: 'football',
    isGraded: true,
  },
  {
    id: '19',
    title: 'Vladimir Guerrero Jr. 2019 Topps Chrome Rookie Card',
    player: 'Vladimir Guerrero Jr.',
    team: 'Toronto Blue Jays',
    year: 2019,
    brand: 'Topps Chrome',
    condition: 'Near Mint',
    price: 1500,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Guerrero+2019+Raw',
    description: 'Vladimir Guerrero Jr. 2019 Topps Chrome Rookie Card in Near Mint condition. Power hitter.',
    ebayUrl: 'https://www.ebay.com/itm/example19',
    sport: 'baseball',
    isGraded: false,
  },
  {
    id: '20',
    title: 'Ja Morant 2019 Panini Prizm Rookie Card',
    player: 'Ja Morant',
    team: 'Memphis Grizzlies',
    year: 2019,
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 3800,
    imageUrl: 'https://via.placeholder.com/300x400/FFD700/000000?text=Morant+2019+PSA+10',
    description: 'Ja Morant 2019 Panini Prizm Rookie Card in PSA 10 condition. High-flying point guard.',
    ebayUrl: 'https://www.ebay.com/itm/example20',
    sport: 'basketball',
    isGraded: true,
  },
]; 